import React from "react";
import { Linkedin, Facebook, Instagram, Youtube } from "lucide-react";
import { SiMedium } from "react-icons/si";
import { Link } from "react-router-dom";

const SOCIALS = [
  { label: "LinkedIn", href: "https://www.linkedin.com/company/the-digital-marketer-online/", Icon: Linkedin },
  { label: "Facebook", href: "https://www.facebook.com/thedigitalmarketer.online", Icon: Facebook },
  { label: "Instagram", href: "https://www.instagram.com/thedigitalmarketeronline/", Icon: Instagram },
  { label: "Medium", href: "https://medium.com/@thedigitalmarketer.online", Icon: SiMedium },
  { label: "YouTube", href: "https://www.youtube.com/@TheDigitalMarketerOnline", Icon: Youtube },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-ink text-paper">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 md:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <div className="font-heading font-black text-4xl md:text-6xl leading-[0.95] tracking-tightest">
              Empowering
              <br />
              your digital
              <br />
              <span className="text-signal">presence.</span>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/60 mb-4">
              Navigate
            </div>
            <ul className="space-y-3 font-heading font-bold">
              {[
                { l: "About", to: "/#about" },
                { l: "Expertise", to: "/#services" },
                { l: "Credentials", to: "/#certifications" },
                { l: "Writing", to: "/blog" },
                { l: "Audits", to: "/linkedin-ads-audit" },
                { l: "Playbook", to: "/playbook" },
                { l: "Contact", to: "/#contact" },
              ].map(({ l, to }) => (
                <li key={l}>
                  <Link to={to} className="hover:text-signal transition-colors">
                    {l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <div className="font-mono text-[10px] uppercase tracking-[0.22em] text-paper/60 mb-4">
              Elsewhere
            </div>
            <ul className="space-y-3">
              {SOCIALS.map(({ label, href, Icon }) => (
                <li key={label}>
                  <a
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-2 hover:text-signal transition-colors font-heading font-bold"
                  >
                    <Icon size={14} />
                    {label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 md:mt-20 pt-8 border-t border-paper/20 flex flex-col md:flex-row items-start md:items-center justify-between gap-4 font-mono text-[11px] uppercase tracking-[0.22em] text-paper/60">
          <span>© {new Date().getFullYear()} Abhinav Dhiman · The Digital Marketer</span>
          <span>Rebuilt with intention · Remote <span className="text-signal">→</span> Worldwide</span>
        </div>
      </div>
    </footer>
  );
}
